var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"cardMedia",attrs:{"width":"180","color":"lightGray"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"text-subtitle-2 ma-2 title"},'div',attrs,false),on),[_vm._v(_vm._s(_vm.cardTitle))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tip))])]),_c('div',{staticClass:"text-subtitle-2 ma-2"},[_vm._v(_vm._s(_vm.cardTime))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }